import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthLayout } from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AcceptInvitation() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) { setError("Token mancante"); return; }
    api.get(`/invitations/${token}`)
      .then(({ data }) => setInvite(data.data))
      .catch((e) => setError(apiError(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Le password non coincidono");
    setLoading(true);
    try {
      const { data } = await api.post("/invitations/accept", { token, password });
      localStorage.setItem("cx_access_token", data.data.access_token);
      localStorage.setItem("cx_refresh_token", data.data.refresh_token);
      setUser(data.data.user);
      toast.success("Invito accettato! Benvenuto.");
      navigate("/dashboard");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Accetta l'invito" subtitle="Imposta la password per unirti al team">
      {error ? (
        <div className="space-y-4" data-testid="invite-error">
          <div className="rounded-xl border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive">{error}</div>
          <Link to="/login"><Button variant="outline" className="w-full rounded-lg">Torna al login</Button></Link>
        </div>
      ) : !invite ? (
        <div className="flex justify-center py-8"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="invite-form">
          <div className="rounded-xl border border-border bg-muted/40 p-4 text-sm">
            <p><span className="text-muted-foreground">Azienda:</span> <span className="font-medium">{invite.company_name}</span></p>
            <p><span className="text-muted-foreground">Email:</span> {invite.email}</p>
            <div className="mt-1">Ruolo: <Badge variant="secondary">{invite.role_label}</Badge></div>
          </div>
          <div className="space-y-2">
            <Label>Password</Label>
            <Input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="invite-password" />
          </div>
          <div className="space-y-2">
            <Label>Conferma password</Label>
            <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="invite-confirm" />
          </div>
          <Button type="submit" className="w-full rounded-lg" disabled={loading} data-testid="invite-submit">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Accetta e accedi
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
